import { useContext, useMemo } from 'react'

import { UnleashContext } from 'components'
import { useAccountContext } from 'components/contexts/AccountContext'
import { useConnectedUserContext } from 'components/contexts/ConnectedUserContext'

const useTenantsApp = (): boolean => {
  const iAm = useConnectedUserContext()
  const { tenantsEnabled } = useContext(UnleashContext)
  const { licensesDetails, accountKey } = useAccountContext()
  const selectedAccount = iAm?.accounts?.find((account) => account.key === accountKey)
  const isSuperUser = selectedAccount?.adminRoles?.includes('SUPER_USER')
  const tenantsProvisioned = useMemo(
    () => licensesDetails?.entitlements?.GOTORESOLVE?.tenantsProvisioned,
    [licensesDetails],
  )

  return tenantsEnabled && !!isSuperUser && !!tenantsProvisioned
}

export default useTenantsApp
